import JsonUtils from "@/utils/JsonUtils";

export default class CloneUtils{
  static clone(obj: any){
    return JSON.parse(JSON.stringify(obj), JsonUtils.parse);
  }
}

